import { isPast } from 'date-fns';

export const isPastDate = (date: Date) => {
  const _date = new Date(date);
  _date.setHours(23);
  _date.setMinutes(59);
  _date.setSeconds(59);
  return isPast(_date);
};
